// Vendor imports
const Immutable = require('immutable')
// Common Client V2 imports
const {
  defaultReviver,
  keyedReviver
} = require('client-v2/common/state/record-reviver')

class LocationRecord extends Immutable.Record({
  pathname: String(),
  search: String(),
  hash: String(),
  state: undefined,
  key: undefined
}) {
  get href() {
    return this.pathname + this.search + this.hash
  }
}

const reviver = keyedReviver(LocationRecord, {
  state: defaultReviver
})

module.exports = Object.assign(LocationRecord, {
  reviver
})
